import { GeneralSettings, LogManager, ValueResolver } from "@mcleod/core";
import { Component } from "@mcleod/components";
import { AbstractUIDesigner } from "./AbstractUIDesigner";
import { LayoutDesignerTab } from "./LayoutDesignerTab";
import { LocalStorageManager } from "../common/LocalStorageManager";

const log = LogManager.getLogger("common.designer.UIDesigner");

export class UIDesigner extends AbstractUIDesigner {
    constructor(props?) {
        super({
            ...props,
            endpointPath: "layout",
            localStorageManager: new LocalStorageManager("designer.ui.open", "designer.ui.selected"),
            title: "UI Designer"
        })
    }

    get allowedDesignerTools(): string[] {
        return [
            "label",
            "textbox",
            "button",
            "checkbox",
            "radiobox",
            "radiobuttongroup",
            "switch",
            "table",
            "image",
            "citystate",
            "splitter",
            "tree",
            "map",
            "panel",
            "stepper",
            "tabset",
            "repeater",
            "list",
            "attachment",
            "layout",
            "layoutheader",
            "horizontalspacer",
            "searchbutton",
            "searchpanel",
            "savebutton",
            "dataheader",
            "numbereditor",
            "starrating",
            "progressbar",
            "chart",
            "location",
            "iframe",
            "excludabletextbox",
            "unitinputfield",
            "daterangefilter"
        ].sort((a, b) => a.localeCompare(b));
    }

    override filterProps(props: any, selectedComponent: Component) {
        super.filterProps(props, selectedComponent);
        for (const key of Object.keys(props)) {
            log.debug("Evaluating property for UI Designer visibility: %o for component", props[key]);
            const visibleInDesigner = ValueResolver.resolve(props[key].visibleInDesigner, selectedComponent);
            if (visibleInDesigner === false) {
                log.debug("Removing property from UI Designer: %o", props[key]);
                delete props[key];
            }
        }
    }

    override disablePropertyEditors(prop: any, editorComponents: Component[], selectedComponent: Component): void {
        log.debug("Evaluating property for UI Designer editability: %o for component %o", prop, selectedComponent);
        const isEditable = prop.editableInDesigner == null ? true : prop.editableInDesigner;
        if (isEditable !== true) {
            log.debug("Disabling edit of property within UI Designer: %o", prop);
            for (const component of editorComponents) {
                component.enabled = false;
            }
        }
    }

    override updateToolbarButtonVisibility(tab: LayoutDesignerTab) {
        if (GeneralSettings.getSingleton().isRunningInIDE() === true) {
            this.buttonManageVersions.visible = false;
            this.buttonSaveNewVersion.visible = false;
        }
        else
            super.updateToolbarButtonVisibility(tab);
    }
}
